export const complexColumn = (element, columns, formatter = (value) => value) => columns.map(column => {
  let fields = column.fields.split('.');
  if (fields.length === 0)
    return null;
  let value = element[fields[0]];
  for (let i = 1; i < fields.length; ++i) {
    if (value === null)
      return null;
    value = value[fields[i]];
  }
  if (value === null)
    return null;
  if (column.condition === undefined || column.condition === null || column.condition(element))
    return `${column.label}: ${formatter(value)}`;
  return null;
}).filter(el => el !== null).join(', ');

export const jsonColumn = (object, captions) => {
  if (object === null)
    return null;
  return Object.keys(object).map(key => {
    if (captions[key] === undefined)
      return null;
    return `${captions[key].toLowerCase()}: ${object[key]}`;
  }).filter(element => element !== null).join('; ');
};



// WEBPACK FOOTER //
// ./src/components/tableUtils.js